import './IssueFeedback.css';
import React, { useRef, useState } from 'react';
import SelectComponent from './SelectComponent';
import { getAppBackendUrl } from '../../config';

function IssueFeedback({ onRequestComplete, productType, defaultEmail = '', defaultPhone = '' }) {
  const API_URL = getAppBackendUrl();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const [issueDescription, setIssueDescription] = useState('');
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState(defaultPhone);
  const [email, setEmail] = useState(defaultEmail);
  const [orderSource, setOrderSource] = useState('Amazon');

  const issueRef = useRef(null);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const emailRef = useRef(null);

  const isFormActive =
    issueDescription.trim().length > 0 &&
    name.trim().length > 0 &&
    (phoneNumber.trim().length > 0 || email.trim().length > 0);

  const handleSelectChange = (selectedOption) => {
    setOrderSource(selectedOption);
  };

  function callbackIssueFeedback(status, json) {
    console.log('[IssueFeedback] HTTP status:', status, 'responseText:', json);
    try {
      const jsonObject = window.JSON.parse(json);
      if (jsonObject.code === 200) {
        onRequestComplete();
      } else {
        setSubmitError("Your request wasn't sent. Please try again.");
        console.error('[IssueFeedback] error response:', jsonObject);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('[IssueFeedback] JSON parse error:', error, 'raw response:', json);
      setSubmitError("Your request wasn't sent. Please try again.");
      setIsSubmitting(false);
    }
  }

  const submitIssueFeedback = (callback) => {
    const httpRequest = new XMLHttpRequest();
    httpRequest.open('POST', `${API_URL}/issue-feedback/submit`, true);
    httpRequest.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    const data = JSON.stringify({
      name,
      email,
      phoneNumber,
      orderSource,
      issueDescription,
      productType,
    });
    httpRequest.send(data);
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4) {
        callback(httpRequest.status, httpRequest.responseText);
      }
    };
  };

  const handleSubmit = () => {
    if (issueDescription.trim() === '') {
      setSubmitError('Please describe your issue.');
      issueRef.current && issueRef.current.focus();
      return;
    }
    if (name.trim() === '') {
      setSubmitError('Please enter a valid name.');
      nameRef.current && nameRef.current.focus();
      return;
    }
    if (phoneNumber.trim() === '' && email.trim() === '') {
      setSubmitError('Please enter a phone number or email address.');
      phoneRef.current && phoneRef.current.focus();
      return;
    }
    if (email.trim() !== '') {
      const isValidEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(email.toLowerCase());
      if (!isValidEmail) {
        setSubmitError('The email format is incorrect.');
        emailRef.current && emailRef.current.focus();
        return;
      }
    }

    setSubmitError('');
    setIsSubmitting(true);
    submitIssueFeedback(callbackIssueFeedback);
  };

  return (
    <div className="si-container">
      <div className="si-content">
        <div className="si-title">Contact Support</div>
        <div className="si-subtitle">Drop us your phone and email, we'll be in touch within 24 business hours.</div>

        <div className="si-label">Describe Your Issue</div>
        <div className="si-textarea-wrapper">
          <textarea
            ref={issueRef}
            className="si-textarea"
            placeholder="Please describe the problem you are experiencing"
            maxLength={999}

            value={issueDescription}
            onChange={(e) => setIssueDescription(e.target.value)}
          />
          <div className="si-char-count">{issueDescription.length}/999</div>
        </div>

        <div className="si-label">Purchase Source</div>
        <div className="si-select-wrapper">
          <SelectComponent onSelectChange={handleSelectChange} />
        </div>

        <div className="si-label">User Name</div>
        <input
          ref={nameRef}
          className="si-input"
          placeholder="Please enter your name"
          readOnly={isSubmitting}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <div className="si-label">Phone Number</div>
        <input
          ref={phoneRef}
          className="si-input"
          placeholder="Please enter mobile number"
          type="tel"
          readOnly={isSubmitting}
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />

        <div className="si-label">Email Address</div>
        <input
          ref={emailRef}
          className="si-input"
          placeholder="Please enter email address"
          type="email"
          readOnly={isSubmitting}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <div className="si-submit-wrapper">
          {submitError && <div className="si-submit-tooltip">{submitError}</div>}
          <button
            className={`si-submit-btn ${isFormActive ? 'si-submit-btn--active' : ''}`}
            disabled={!isFormActive || isSubmitting}
            onClick={handleSubmit}
          >
            {isSubmitting ? 'Submitting...' : submitError ? 'Try Again' : 'Submit'}
          </button>
        </div>

        <div style={{ height: 40 }} />
      </div>

    </div>
  );
}

export default IssueFeedback;
